import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IEssentialsModule } from '@devinforius/i-essentials';
import { ToastModule } from 'primeng/toast';
import { LoadingComponent } from './components/loading/loading.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@NgModule({
  declarations: [LoadingComponent],
  imports: [CommonModule, ProgressSpinnerModule],
  exports: [IEssentialsModule, ToastModule, LoadingComponent],
})
export class SharedModule {}
